import React from 'react'

const HowSheetWork = ({isProf, translate}) => {
  return (
    <>
    <div className={`how__it_wrks ${!isProf && " hidden"}`}>
                          <div className="how__it_wrks_itm">
                            <div className="nmb__itm">1</div>

                            <small className="smll_inff">
                              {translate(
                                "Select the columns you want to see in the table from the 'Available Columns' list, add extra columns if you want, and send the columns you selected to the 'Selected Columns' area by clicking the 'Export to Right' button, which turns blue."
                              )}
                            </small>
                          </div>
                          <div className="how__it_wrks_itm">
                            <div className="nmb__itm">2</div>
                            <small className="smll_inff">
                              {translate(
                                "In the 'Selected Columns' field, you can change the order in which you want the columns to appear in the table by dragging and dropping the 'Burger' icon that appears to the right of the column objects. Or you can re-select the column you want to remove and send it to the 'Available Columns' field by clicking on the 'Export Left' button, which turns blue."
                              )}
                            </small>
                          </div>
                          <div className="how__it_wrks_itm">
                            <div className="nmb__itm">3</div>
                            <small className="smll_inff">
                              {translate(
                                "Finally, you need to record both the columns you selected and your ranking. Give a name to your setting in the 'Setting name' field and make it active by clicking on it if you want to use it. Now, by clicking the 'Google Sheet' button from the plugin, the products you send can be transferred to your Google Sheet account with the columns and order you want."
                              )}
                            </small>
                          </div>
                        </div>
    </>
  )
}

export default HowSheetWork